module.exports = __webpack_public_path__ + "images/FUSA_icons/087-telephone.408ef77b7cf90c3b1def29d387aaf946.svg";